import { useState } from "react";
import BanTimesSCP from "../../../../../../../../Services/Data/SCP/BanTimesSCP";
import ButtonGrid from "../../../../../Components/ButtonGrid/ButtonGrid";

import { AddToastNotification } from "../../../../../../../../Services/ToastNotification/ToastNotificationManager";

const CustomReason = ({executeBan, getOnlinePlayers, getOfflinePlayers}) => {
    const [selected, setSelected] = useState(-1);
    const [reason, setReason] = useState("");
    
    const ban = () => 
    {
        const onlinePlayerCount = getOnlinePlayers().length;
        const offlinePlayerCount = getOfflinePlayers().length;

        if(onlinePlayerCount == 0 && offlinePlayerCount == 0){
            AddToastNotification("Musisz wybrać gracza/graczy!", 0);
            return;
        }
            
        if(selected == -1)
        {
            AddToastNotification("Musisz wybrać czas!", 0)
            return;
        }

        if(!reason)
        {
            AddToastNotification("Musisz podać powód!", 0)
            return;
        }

        executeBan(BanTimesSCP[selected].time, reason, () => {});
    }

    return (
        <div className="flex flex-col items-center">
            <div className="mt-10">
                <ButtonGrid className={"grid-cols-[repeat(9,4vw)]"} buttons={BanTimesSCP} selected={selected} setSelected={setSelected}/>
            </div>

            <input onChange={e => setReason(e.target.value)} placeholder="Specify a reason behind the sanction." className="input w-90p mt-10"/>
            <div onClick={() => ban()} className="remoteAdminButton m-auto w-[35%] mt-10">Request</div>
        </div>
    )
};

export default CustomReason;